<template>
  <!-- 服务商提交资料 -->
  <div class="jsFrom">
    <el-form>
      <div class="title">
        完善资料
      </div>
      <div>
        <p class="item">基本信息</p>
        <el-card>
          <!-- <el-row>
            <el-col :span="4" :xs="8">帐号(手机号)</el-col>
            <el-col :span="20" :xs="16">
              <el-form-item :error="errorBags.collect('帐号(手机号)')[0]">
                <el-input
                  placeholder="请输入帐号"
                  v-model="createObj.bizParam.userInfoMobile"
                  v-validate="'required|phone'"
                  name="帐号(手机号)"
                  maxlength="11">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8">密码</el-col>
            <el-col :span="20" :xs="16">
              <el-form-item :error="errorBags.collect('密码')[0]">
                <el-input
                  placeholder="请输入密码"
                  v-model="createObj.bizParam.password"
                  name="密码"
                  v-validate="'required'"
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="4" :xs="8"><i class='el-icon-star-on iconStart'></i>公司名称</el-col>
            <el-col :span="20" :xs="16">
              <el-form-item :error="errorBags.collect('公司名称')[0]">
                <el-input
                  placeholder="请输入公司名称"
                  name="公司名称"
                  v-validate="'required'"
                  v-model="createObj.bizParam.name">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="userType === '4'">
            <el-col :span="4" :xs="8">公司简称</el-col>
            <el-col :span="20" :xs="16">
              <el-input placeholder="请输入公司简称" v-model="merchant_extend.shortName"></el-input>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="4" :xs="8">公司品牌</el-col>
            <el-col :span="20" :xs="16">
              <el-input placeholder="请输入公司品牌" v-model="merchant_extend.brandName"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8"><i class='el-icon-star-on iconStart'></i>联系人</el-col>
            <el-col :span="20" :xs="16">
              <el-form-item :error="errorBags.collect('联系人')[0]">
                <el-input
                  placeholder="请输入联系人"
                  name="联系人"
                  v-validate="'required'"
                  v-model="createObj.bizParam.mainPerson"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8"><i class='el-icon-star-on iconStart'></i>联系方式</el-col>
            <el-col :span="20" :xs="16">
              <el-form-item :error="errorBags.collect('联系方式')[0]">
                <el-input
                  placeholder="请输入联系方式"
                  v-model="createObj.bizParam.mobile"
                  name="联系方式"
                  v-validate="'required|phone'"
                  maxlength="11">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8"><i class='el-icon-star-on iconStart'></i>公司地址</el-col>
            <el-col :span="20" :xs="16">
              <city class='city' :isXian="true" @Citychange="companyAddress" :showAdd="false"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8"><span style="height:20px;display:block"></span></el-col>
            <el-col :span="20" :xs="16">
              <el-form-item :error="errorBags.collect('详细地址')[0]">
                <el-input
                  placeholder="请输入详细地址"
                  type="textarea"
                  name="详细地址"
                  v-validate="'required'"
                  v-model="createObj.bizParam.address"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8">备注</el-col>
            <el-col :span="20" :xs="16">
              <el-input type="textarea" v-model="merchant_extend.remark"></el-input>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <div v-if="userType === '4'">
        <p class="item">服务信息</p>
        <el-card>
          <el-row>
            <el-col :span="4" :xs="8"><i class='el-icon-star-on iconStart'></i>服务范围</el-col>
            <el-col :span="20" :xs="16">
              <city class='city' :isXian="true" @addCity="addCityIds" :showAdd="true"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8"><i class='el-icon-star-on iconStart'></i>服务城市</el-col>
            <el-col :span="20" :xs="16">
              <el-tag
                v-for="(tag, index) in cityIds"
                :key="tag.cityId"
                closable
                @close="deleteCity(index)"
                >
                {{tag.cityName}}
              </el-tag>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :xs="8"><i class='el-icon-star-on iconStart'></i>服务品类</el-col>
            <el-col :span="20" :xs="16">
              <el-checkbox-group v-model="copyBox">
                <el-checkbox v-for="(val,key) in allBox" :key="key" :label="val.id">{{ val.name }}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <div class="buttonBox">
        <el-button type="primary" size="small" style="text-align:center" @click='checkForm'>{{btnMessage}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import city from '@/components/common/city'
import model from '@/libs/models'
import { productApi, workApi } from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      serviceType: [],
      userType: 1,
      copyBox: [],
      allBox: [],
      cityIds: [],
      btnMessage: '',
      merchant_extend: {
        brandName: '',
        remark: '',
        shortName: ''
      },
      addressObj: {},
      cityId: '',
      areaId: '',
      provinceId: '',
      createObj: Object.assign({}, model.merchantObj)
    };
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.userType = this.$route.query.userType
    this.btnMessage = (this.userType === '4') ? '注册服务商' : '注册供应商'
    this.createObj.bizParam.userInfoMobile = this.user.mobile
    this.getSkillTree()
  },
  components: {
    city
  },
  methods: {
    // 注册商户
    async check () {
      let params = this.createObj
      Object.assign(params.bizParam, this.addressObj)
      if (this.userType === '4') {
        params.bizParam.category = 0
        params.bizParam.cityIds = this.cityIds.map(item => {
          return item.cityId
        }).join(',')
        params.bizParam.serviceCategoryIds = this.copyBox.join(',')
      } else {
        params.bizParam.category = 1
        params.bizParam.merchant_extend = JSON.stringify(this.merchant_extend)
      }
      try {
        let data = (await workApi.applymerchant(params)).data
        if (data.statusCode === 200) {
          this.$message.success('注册成功')
          this.$router.push({
            path: '/worker/checkResult',
            query: {
              userType: this.userType,
            }
          });
        }
      } catch (err) {
        console.error(err)
      } finally {

      }
    },
    // 公司地址
    companyAddress(result) {
      this.addressObj.provinceId = result.sheng.code
      this.addressObj.cityId = result.shi.code
      this.addressObj.areaId = result.xian.code
    },
    addCityIds(data) {
      this.cityIds = data
    },
    deleteCity(index) {
      this.cityIds.splice(index, 1)
    },
    // 服务类目
    async getSkillTree() {
      try {
        let data = (await productApi.getSkillTree()).data
        this.allBox = data.data;
      } catch (err) {
        console.error(err)
      } finally {

      }
    },
    checkForm() {
      this.$validator.validate().then(status => {
        if (status) {
          if (!this.addressObj.cityId) {
            this.$message.error('请选择公司地址');
            return
          }
          if (this.userType === '4') {
            if (this.cityIds.length === 0) {
              this.$message.error('请选择服务城市');
              return
            }
            if (this.copyBox.length === 0) {
              this.$message.error('请选择服技能');
              return
            }
          }
          this.check();
        } else {
          this.$message.error('请正确填写数据');
        }
      });
    }
  }
};
</script>

<style scoped lang='less'>
@import "../../assets/styles/work.less";
</style>

